import { PlotDetailPage } from '@/components/plots/plot-detail-page'

export function CommitteePlotDetail() {
  return (
    <PlotDetailPage
      plotsBasePath="/committee/plots"
      membersBasePath="/committee/members"
      canManage={false}
    />
  )
}
